const tvAction: { url?: any, analytics?: any} = window["tvAction"] = {};

if (!tvAction.url){
  tvAction.url = {
    pfEndPoint:'https://powerforward-ui.dev.k12.com/computer-fulfillment',
    endpoint: 'https://tvaction-aws-dev.k12.com/tvaction',
    // endpoint: 'http://localhost:4200/api', // USE THIS WHEN PROXY
    tvSchoolEndPoint:'https://internal-totalviewva-aws-devci.k12.com/cgi-bin/WebObjects/TotalViewVA.woa',
    tvEnrollmentEndPoint: 'https://internal-totalviewenrollment-aws-devci.k12.com/cgi-bin/WebObjects/TotalViewEnrollment.woa',
    tvKmailEndPoint: 'https://internal-kmail-aws-devci.k12.com/cgi-bin/WebObjects/KMail.woa'
  };

  tvAction.analytics = {
    account: 'UA-77180432-2',
    domainName: 'https://tvaction-aws-dev.k12.com/tvaction',
    logAllCalls: true,
    enterDebugMode: true
  };
}
